import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { showError, showToast } from "../../constants/toasts";
import { OTP_ENUM } from "../../utils/enums";
import { useFormik } from "formik";
import { useForgotPasswordMutation } from "../../services/auth";
import * as Yup from "yup";
import { Button, TextField } from "@mui/material";
import Loader from "../../constants/Loader";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [ForgotPasswordMutation, { isLoading }] = useForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter valid email address!"
        ),
    }),

    onSubmit: async () => {
      formik.setSubmitting(true);
      const body = {
        email: formik.values.email,
        // otpType: OTP_ENUM.FORGOT_PASSWORD,
      };

      try {
        // const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await ForgotPasswordMutation(body).unwrap();
      

        if (response?.status === 200) {
          const data = {
            email: formik.values.email,
          };
          navigate("/otp", { state: data });
          showToast(response?.message || "OTP sent successfully");
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
      }
    },
  });
  return (
    <AuthLayout>
      <Loader isLoad={isLoading} />
      <div className="authBox">
        <h2>Forgot Password</h2>
        <p>Please provide your email address to reset your password</p>
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label>Email Address</label>
            <TextField
              placeholder="Enter Email Address"
              hiddenLabel
              fullWidth
              className="text_field"
              name="email"
              type="email"
              variant="outlined"
              id="email"
              onChange={(val) => {
                if (val.target.value === " " || val.target.value === ".") {
                  /* empty */
                } else {
                  formik.handleChange(val);
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              helperText={formik.touched.email && formik.errors.email}
            />
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" type="submit">
              Submit
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <span className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </span>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
